import { BundleKey } from './types'

interface BundleDetail {
  name: string
  subheading?: string
  description: string
  price: string
}

interface Layouts {
  [key: string]: {
    order: BundleKey[]
    highlight: BundleKey
  }
}

export const layouts: Layouts = {
  cw: {
    order: ['csp', 'cw'],
    highlight: 'csp',
  },
  cwnft: {
    order: ['csp', 'cwnft'],
    highlight: 'csp',
  },
}
export const BUNDLE_CW = 'Chegg Writing'
export const BUNDLE_CSP = 'Chegg Study Pack'
export const bundleDetailsByKey: { [k: string]: BundleDetail } = {
  csp: {
    name: BUNDLE_CSP,
    description: 'Our best study tools together',
    price: '$19.95',
  },
  cw: {
    name: BUNDLE_CW,
    subheading: 'with 3-day free trial¹',
    description: 'The basics',
    price: '$9.95',
  },
  cwnft: {
    name: BUNDLE_CW,
    description: 'The basics',
    price: '$9.95',
  },
}

interface FeatureInfo {
  name: string
  description: string
  bundles: BundleKey[]
  disclaimerFlag?: string
  isNew?: boolean
}

export const featureList: FeatureInfo[] = [
  {
    name: 'Writing Help',
    description:
      'Plagiarism checks, grammar fixes, and easy citations to help you turn in your best paper',
    bundles: ['csp', 'cw', 'cwnft'],
  },
  {
    name: 'Quiz & Exam Help',
    description: 'Study and learn with practice quizzes for your courses',
    disclaimerFlag: '**',
    bundles: ['csp'],
  },
  {
    name: 'Math Help',
    description: 'Learn the how & why to solve tough equations with steps & sub-steps',
    bundles: ['csp'],
  },
  {
    name: 'Homework Help',
    description:
      'Access to 35 million Textbook Solutions and Expert Q&A, plus ask new questions to our experts',
    disclaimerFlag: '*',
    bundles: ['csp'],
  },
]

export interface DisclaimerText {
  flag: string
  content: string
  testIDToken: string
}

export const disclaimers: DisclaimerText[] = [
  {
    flag: '*',
    content: 'Experts’ time to respond varies by subject and question',
    testIDToken: 'first',
  },
  {
    flag: '**',
    content: 'Content not available for all Textbook Solutions or subjects',
    testIDToken: 'second',
  },
]



// WEBPACK FOOTER //
// ./src/pages/Plans/data.ts